import Axios from '../config/Axios';

export const getPermissionList = async () => {
  const response = await Axios.get('system/permissions');
  return response.data;
};

/**
 * @param {number} nAdmId
 */
export const getUser = async nAdmId => {
  const response = await Axios.get(`admin/${nAdmId}`);
  return response.data;
};
